import axios from "axios";
import { CommonHttp } from "@/models/interfaces/http/common.http.request";
import {ClientContactsRequest} from "@/store/client-page";
import { ClientInfoFull } from "@/models/interfaces/client/client-info";
import { CommonEntityRecord } from "@/models/interfaces/common";
import { AddressInputContainer } from "@/models/interfaces/entity-settings";
import type { ClientFilterOption } from "@/store/search";


export type AttachClient = {
    Id: number,
    Name: string,
    Address: string[]
}

export class ClientsApi {
    // Получение объекта с данными клиента на странице Клиента
    static getClient(clientId: number): Promise<any> {
        const http = new CommonHttp()
        return http
            .get(`clients/${clientId}`,)
            .then(data => {
                if (axios.isAxiosError(data)) {
                    throw data
                }
                return data.data
            })
    }

    // Переименование клиента
    static renameClient(entityId: number, name: string): Promise<any> {
        const http = new CommonHttp()
        return http
            .patch(`clients/rename`, { name, entityId })
            .then(data => data.data)
    }

    // Сохранение адреса клиента (id — Id клиента, container — цепочка адреса)
    static setClientAddress(id: number, container: AddressInputContainer): Promise<any> {
        const http = new CommonHttp()
        return http
            .patch(`address/client/set`, { container, id })
            .then(data => data.data)
    }

    // Получение подробной информации о клиенте (для модалки)
    static getClientInfo(clientId: number): Promise<ClientInfoFull> {
        const http = new CommonHttp()
        return http
            .get(`clients/${clientId}/info`)
            .then(data => data.data)
    }

    // Получение списка контактов на странице Клиента
    static getContactsForClient(requestModel: ClientContactsRequest): Promise<any> {
        const http = new CommonHttp()
        return http
            .post(`persons/search/client`, requestModel)
            .then(data => data.data)
    }

    // Получение списка клиентов для присоединения к холдингу
    static getAttachClientsList(Id: number, Filter: string, Skip: number, Take: number): Promise<AttachClient[]> {
        const http = new CommonHttp()
        return http
            .get(`clients/attach/list?Id=${Id}&Filter=${encodeURIComponent(Filter)}&Skip=${Skip}&Take=${Take}`)
            .then(data => data.data)
    }

    // Присоединение клиента к холдингу текущего клиента
    static attachClient(clientId: number, entityIdToAttach: number): Promise<any> {
        const http = new CommonHttp()
        return http
            .put(`clients/attach`, { entityIdToAttach, clientId })
            .then(data => {
                if (axios.isAxiosError(data)) {
                    throw data
                }
                return data.data
            })
    }

    // Отсоединение клиента от холдинга текущего клиента
    static detachClient(clientId: number, entityIdToAttach: number): Promise<any> {
        const http = new CommonHttp()
        return http
            .put(`clients/detach`, { entityIdToAttach, clientId })
            .then(data => data.data)
    }

    // Удаление клиента
    static deleteClient(clientId: number): Promise<any> {
        const http = new CommonHttp()
        return http
            .delete(`clients?Id=${clientId}`)
            .then(data => data.data)
    }

    // Создание нового клиента
    static createClient(id: number): Promise<number> {
        const http = new CommonHttp()
        return http
            .post(`clients?Id=${id}`, {})
            .then(data => data.data)
    }

    // Клиент для фильтра поиска по проектам на странице Клиента
    static getClientFilter(clientId: number): Promise<ClientFilterOption> {
        const http = new CommonHttp()
        return http
            .get(`clients/${clientId}/filter/client`)
            .then(data => data.data)
    }

    // Список клиентов для фильтра поиска по проектам на странице Проекта
    static getProjectFilter(projectId: number): Promise<ClientFilterOption[]> {
        const http = new CommonHttp()
        return http
            .get(`clients/${projectId}/filter/project`)
            .then(data => data.data)
    }

    // Актуальные роли клиента (для привязки к выбранному в фильтре клиенту)
    static getActualRoles(): Promise<CommonEntityRecord[]> {
        const http = new CommonHttp()
        return http
            .get(`client/role/actual`)
            .then(data => data.data)
    }
}
